import { render, staticRenderFns } from "./TelephoneField.vue?vue&type=template&id=1460083a&"
import script from "./TelephoneField.vue?vue&type=script&lang=ts&"
export * from "./TelephoneField.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports